export function formatNumber( number: number ): string {
	const numberAsAString = number.toString();

	if ( 100000 > number ) {
		return `${numberAsAString.slice( -5, -2 )},${numberAsAString.slice( -2 )}`;
	}

	return `${numberAsAString.slice( 0, -5 )}.${numberAsAString.slice( -5, -2 )},${numberAsAString.slice( -2 )}`;
}

export function formatNumberWithoutDecimals( number: number ): string {
	const numberAsAString = number.toString();

	if ( number < 100000 ) {

		// '1000'
		return `${numberAsAString.slice( -5, -2 )}`;
	}

	return `${numberAsAString.slice( 0, -5 )}.${numberAsAString.slice( -5, -2 )}`;
}
